<template>
   <div id="media_picker" class="blue-bckgd">
      <div class="media-picker-wrapper">

         <media-picker-header
            :assetType="assetType"
            :isBlock="block != undefined">
         </media-picker-header>

         <media-picker-menu
            :channelRecid="channelRecid"
            :assetType="selectedAssetType"
            :activeAssetId="activeAssetId"
            :isScoreboard="isScoreboard"
            :multiSelect="multiSelect"
         ></media-picker-menu>

      </div> 
   </div>
</template>

<script>
import MediaPickerHeader from './MediaPickerHeader';
import MediaPickerMenu from './MediaPickerMenu';
import { mapActions, mapState } from 'vuex';
// import { EventBus } from './../../event-bus.js';

export default {
   data() {
      return {
         templateId: '',
         templateName: '',
         selectedInstance: '',
         sortOn: 'c_creation',
         deleteState: false,

         searchKeyword: '',
         mediaPickerActive: true,

         slotTable: false,

         selectedAssetType: this.assetType instanceof Array ? this.assetType[0] : this.assetType
      }
   },

   props: {
      channels: Array,
      channelRecid: Number | String,
      block: Boolean,
      slots: [],
      assetType: Number | String,
      activeId: Number | String,
      activeAssetId: Number | String,
      isScoreboard: Boolean,
      multiSelect: Boolean
   },

   created() {
      let self = this;
      this.$on('typeClicked', (type) => {
         self.handleTypeClicked(type);
      });
      this.initData({
         channels            : this.channels,
         channelRecid        : this.channelRecid,
         assetType           : this.assetType,
         activeId            : this.activeId,
         currActiveAssetRecid: this.activeAssetId,
         multiSelect         : this.multiSelect,
         isScoreboard        : this.isScoreboard
      });
   },

   methods: {
      ...mapActions('global', [
         'initData'
      ]),

      saveSlots() {
         // EventBus.$emit('close-mp-save');
      },

      handleTypeClicked(newType) {
         this.selectedAssetType = newType;
      }
   },

   components: {
      MediaPickerHeader,
      MediaPickerMenu,
   },

   watch: {
      assetType() {
         this.selectedAssetType = this.assetType instanceof Array ? this.assetType[0] : this.assetType;
      },

      activeId() {
         this.initData({
            channelRecid        : this.channelRecid,
            assetType           : this.assetType,
            activeId            : this.activeId,
            currActiveAssetRecid: this.activeAssetId,
            multiSelect         : this.multiSelect
         });
      },

      activeAssetId() {
         this.initData({
            channelRecid        : this.channelRecid,
            assetType           : this.assetType,
            activeId            : this.activeId,
            currActiveAssetRecid: this.activeAssetId,
            multiSelect         : this.multiSelect
         });
      },
   }

}
</script>


<style lang="scss" scoped>
#media_picker {
   // position: relative;
   z-index: 9999;
   color: white;
   position: fixed;
   top: 0;
   left: 0;
   min-height:100%;
   box-shadow: 5px 3px 11px 0px #000000;

   .media-picker-wrapper {
      float: left;
      width: 400px;
      height: 100%;
      // min-height: 100vh;
   }
}
</style>
